module["exports"] = [
  "Nederland"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/nl/address/default_country.js
// module id = 1189
// module chunks = 0